export const SET_STYLE = 'SET_STYLE';
export const SET_SETTING = 'SET_SETTING';
export const SET_CONFIGURATION = 'SET_CONFIGURATION';
export const SET_TRANSLATION = 'SET_TRANSLATION';
export const SET_DEFAULT_TRANSLATION = 'SET_DEFAULT_TRANSLATION';
export const SET_DEFAULT_SETTING = 'SET_DEFAULT_SETTING';

export const setStyle = value => ({
  type: SET_STYLE,
  value,
});

export const setSetting = (key, value) => ({
  type: SET_SETTING,
  key,
  value,
});

export const setConfiguration = value => ({
  type: SET_CONFIGURATION,
  value,
});

export const setTranslation = (key, value) => ({
  type: SET_TRANSLATION,
  value,
  key,
});

export const setDefaultTranslation = value => ({
  type: SET_DEFAULT_TRANSLATION,
  value,
});
export const setDefaultSetting = value => ({
  type: SET_DEFAULT_SETTING,
  value,
});
